<div class="flex flex-col gap-3 text-center items-center">
    <div class="w-12 h-12 flex items-center justify-center rounded-full bg-primary/10 text-primary">
        <i class="pi pi-lock !text-2xl"></i>
    </div>
    <h3 class="text-xl font-bold m-0">Sem acesso</h3>
    <p class="text-muted-color leading-relaxed m-0">Você não tem permissão para acessar este módulo. Se acredita que isso é um engano, fale com o administrador do sistema.</p>
</div>
